import React, { useEffect } from 'react'
import contactimg from './images/contact.png'
import { Link } from 'react-router-dom';

import AOS from 'aos';
import 'aos/dist/aos.css';

const HomeContactForm = () => {
    useEffect(() => {
        AOS.init();
    }, []);

    return (
        <div className='HomeContactForm_section'>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-lg-6 m-auto' data-aos="fade-up" data-aos-duration="2000">
                        <div className='HomeContainer_section_content'>
                            <h3>Register online for free</h3>
                            <p className='text-justify'>Ready to kickstart your journey in technology? Hamo Tech is offering exclusive free registrations for all upcoming courses and events. Don’t miss your chance to join our top-rated training programs and gain the skills you need to succeed in today’s competitive tech industry.</p>
                        </div>
                        <div>
                            <form>
                                {/* <div className='row'>
                                    <div className='col-lg-6 col-12 mt-4'>
                                        <input type='text' placeholder='First Name' className='form-control' />
                                    </div>
                                    <div className='col-lg-6 col-12 mt-4' >
                                        <input type='text' placeholder='Last Name' className='form-control' />
                                    </div>
                                </div>
                                <div className='row mt-4'>
                                    <div className='col-12'>
                                        <input type='text' placeholder='Email *' className='form-control' />
                                    </div>
                                </div>

                                <div className='row mt-4'>
                                    <div className="col-12">
                                        <label className="text-16 lh-1 fw-500 text-dark-1 mb-10">
                                            Category
                                        </label>
                                        <select className="form-control" aria-label="Default select example">
                                            <option hidden>Select Category</option>
                                            <option>student</option>
                                            <option>Job Seeker</option>
                                            <option>Trainer</option>
                                            <option>Lecturer</option>
                                            <option>Developer</option>
                                            <option>IT Professionals</option>
                                            <option>Non - IT</option>

                                        </select>
                                    </div>

                                </div>



                                <div className='row mt-4'>
                                    <div className='col-12'>
                                        <input type='text' placeholder='Phone' className='form-control' />
                                    </div>
                                </div> */}


                              <Link to="/contact-us">  <button>Register Now</button></Link>
                            </form>
                        </div>

                    </div>

                    <div className='col-lg-6' data-aos="fade-up" data-aos-duration="2000">
                        <img src={contactimg} className='img-fluid' />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default HomeContactForm
